
















import { Component, Vue, Prop } from 'vue-property-decorator';
import http from '../tools/http-client';
import TweetComponent from '@/atoms/tweet.vue';
import { Tweet, Type } from '../models/tweet';

@Component({
  components: {
    tweet: TweetComponent,
  },
})
export default class RandomTweetList extends Vue {

  private static AUTO_FETCH_INTERVAL_MS = 5000;

  private tweets: Tweet[] = [];
  private timer?: number;
  private loading: boolean = false;

  @Prop({required: true, default: null})
  private eventPathPhrase!: string | null;

  private mounted(): void {
    this.fetch().then(this.startAutoFetch);
  }

  private get tweetIds(): number[] {
    return this.tweets.map((tweet) => tweet.id);
  }

  private startAutoFetch(): void {
    this.timer = window.setInterval(this.fetch, RandomTweetList.AUTO_FETCH_INTERVAL_MS);
  }

  private async fetch(): Promise<any> {

    if (this.loading) return;

    this.loading = true;

    const response = await http.get<Tweet[]>(`${process.env.VUE_APP_API_URL_BASE}tweets?epp=${this.eventPathPhrase}`);
    const newTweets = response.data.filter((fetchedTweet) => !this.tweetIds.includes(fetchedTweet.id))
      .sort((a, b) => a.id - b.id);

    newTweets.forEach((tweet) => {
      tweet.type = Math.random() > 0.5 ? Type.left : Type.right;
    });
    const pushedIndexes: number[] = [];
    for (let i = this.tweets.length + newTweets.length - 1; i >= this.tweets.length; i--) {
      pushedIndexes.push(i);
    }
    this.tweets = this.tweets.concat(newTweets.map((tweet) => new Tweet(tweet)));

    if (pushedIndexes.length === 0) {
      this.loading = false;
      return;
    }

    this.$nextTick(() => {
      pushedIndexes.forEach((index) => {
        this.setRandomPosition(index);
        this.loading = false;
      });
    });

  }

  private setRandomPosition(refIndex: number): void {

    const areaRef = this.$refs.randomTweetList as HTMLElement;
    const tweetsRef = this.$refs.tweets as HTMLElement[];
    const tweetRef = tweetsRef[refIndex] as HTMLElement;
    const limitWidth = areaRef.clientWidth;
    const limitHeight = areaRef.clientHeight;

    // TODO: 処理時点でのウィンドウサイズからオーバーしないようにする処理なので、ウィンドウを縮小されるとオーバーしてしまう。対応するかどうか。
    const x =  Math.random() * (limitWidth - tweetRef.clientWidth);
    const y = Math.random() * (limitHeight - tweetRef.clientHeight);
    tweetRef.style.left = x + 'px';
    tweetRef.style.top = y + 'px';

    tweetRef.style.zIndex = (1000 + refIndex).toString();

  }

}
